// Stub for fs module in browser environment
// The actual fs is Node.js-only and should only run in the main process

const notAvailable = () => {
  throw new Error('fs is not available in browser environment')
}

// Sync methods
export const existsSync = (): boolean => false
export const readFileSync = notAvailable
export const writeFileSync = notAvailable
export const statSync = notAvailable
export const unlinkSync = notAvailable
export const mkdtempSync = notAvailable
export const renameSync = notAvailable
export const mkdirSync = notAvailable
export const readdirSync = (): string[] => []
export const rmdirSync = notAvailable
export const copyFileSync = notAvailable
export const chmodSync = notAvailable
export const chownSync = notAvailable
export const linkSync = notAvailable
export const lstatSync = notAvailable
export const symlinkSync = notAvailable
export const truncateSync = notAvailable
export const utimesSync = notAvailable
export const accessSync = notAvailable
export const appendFileSync = notAvailable
export const realpathSync = notAvailable
export const openSync = notAvailable
export const closeSync = notAvailable
export const fstatSync = notAvailable
export const ftruncateSync = notAvailable
export const fsyncSync = notAvailable
export const fdatasyncSync = notAvailable
export const readSync = notAvailable
export const fchmodSync = notAvailable
export const fchownSync = notAvailable
export const futimesSync = notAvailable
export const rmSync = notAvailable
export const opendirSync = notAvailable
export const cpSync = notAvailable

// Async methods (callback style)
export const readFile = (_path: string, _options: unknown, callback?: Function) => {
  if (callback) callback(new Error('fs.readFile is not available in browser environment'))
}
export const writeFile = (_path: string, _data: unknown, _options: unknown, callback?: Function) => {
  if (callback) callback(new Error('fs.writeFile is not available in browser environment'))
}
export const mkdir = (_path: string, _options: unknown, callback?: Function) => {
  if (callback) callback(new Error('fs.mkdir is not available in browser environment'))
}
export const readdir = (_path: string, _options: unknown, callback?: Function) => {
  if (callback) callback(null, [])
}
export const stat = (_path: string, callback?: Function) => {
  if (callback) callback(new Error('fs.stat is not available in browser environment'))
}
export const unlink = (_path: string, callback?: Function) => {
  if (callback) callback(new Error('fs.unlink is not available in browser environment'))
}
export const rmdir = (_path: string, _options: unknown, callback?: Function) => {
  if (callback) callback(new Error('fs.rmdir is not available in browser environment'))
}
export const copyFile = (_src: string, _dest: string, callback?: Function) => {
  if (callback) callback(new Error('fs.copyFile is not available in browser environment'))
}
export const rename = (_oldPath: string, _newPath: string, callback?: Function) => {
  if (callback) callback(new Error('fs.rename is not available in browser environment'))
}
export const access = (_path: string, _mode: unknown, callback?: Function) => {
  if (callback) callback(new Error('fs.access is not available in browser environment'))
}
export const watch = notAvailable
export const watchFile = notAvailable
export const unwatchFile = notAvailable

// Stream creation
export const createReadStream = notAvailable
export const createWriteStream = notAvailable

// Promises API
export const promises = {
  readFile: async () => { throw new Error('fs.promises.readFile is not available in browser environment') },
  writeFile: async () => { throw new Error('fs.promises.writeFile is not available in browser environment') },
  mkdir: async () => { throw new Error('fs.promises.mkdir is not available in browser environment') },
  readdir: async (): Promise<string[]> => [],
  stat: async () => { throw new Error('fs.promises.stat is not available in browser environment') },
  unlink: async () => { throw new Error('fs.promises.unlink is not available in browser environment') },
  rmdir: async () => { throw new Error('fs.promises.rmdir is not available in browser environment') },
  rm: async () => { throw new Error('fs.promises.rm is not available in browser environment') },
  copyFile: async () => { throw new Error('fs.promises.copyFile is not available in browser environment') },
  rename: async () => { throw new Error('fs.promises.rename is not available in browser environment') },
  access: async () => { throw new Error('fs.promises.access is not available in browser environment') },
  appendFile: async () => { throw new Error('fs.promises.appendFile is not available in browser environment') },
  open: async () => { throw new Error('fs.promises.open is not available in browser environment') },
}

// Constants
export const constants = {
  F_OK: 0,
  R_OK: 4,
  W_OK: 2,
  X_OK: 1,
  COPYFILE_EXCL: 1,
  COPYFILE_FICLONE: 2,
  COPYFILE_FICLONE_FORCE: 4,
}

export default {
  existsSync,
  readFileSync,
  writeFileSync,
  statSync,
  unlinkSync,
  mkdtempSync,
  renameSync,
  mkdirSync,
  readdirSync,
  rmdirSync,
  copyFileSync,
  chmodSync,
  chownSync,
  linkSync,
  lstatSync,
  symlinkSync,
  truncateSync,
  utimesSync,
  accessSync,
  appendFileSync,
  realpathSync,
  openSync,
  closeSync,
  fstatSync,
  ftruncateSync,
  fsyncSync,
  fdatasyncSync,
  readSync,
  fchmodSync,
  fchownSync,
  futimesSync,
  rmSync,
  opendirSync,
  cpSync,
  readFile,
  writeFile,
  mkdir,
  readdir,
  stat,
  unlink,
  rmdir,
  copyFile,
  rename,
  access,
  watch,
  watchFile,
  unwatchFile,
  createReadStream,
  createWriteStream,
  promises,
  constants,
}
